// extracted by mini-css-extract-plugin
export default {"table":"Payment_table__UYPCr","action":"Payment_action__0-jAv","box":"Payment_box__RKIDR","input":"Payment_input__DOwKc","menuItemActive":"Payment_menuItemActive__mxdv4"};